// extracted by mini-css-extract-plugin
module.exports = {"player":"player_player__EszJa","playerCard":"player_playerCard__3Agsn","buttons":"player_buttons__2jTz2","content":"player_content__2SPv4","playerName":"player_playerName__uIjxH"};